import type { IconData } from '@stacksjs/iconify-core'

export const shoppingDiscount: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6 3a3 3 0 1 1-6 0a3 3 0 0 1 6 0m10 10a3 3 0 1 1-6 0a3 3 0 0 1 6 0M12 0l4 4L4 16l-4-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingDiscount
